// components/Toolbar/tools/SelectTool.js
import React, { useCallback, useEffect } from "react";
import Button from "./Toolbar/Button";
import { connect } from "react-redux";
import DeleteIcon from "../images/Icon20_Delete.svg";
import * as _ from "lodash";
import {
  hideAlertbox,
  showAlertbox,
} from "../../../redux/actions/general/alertbox";
import { __ } from "../../../core/utils";
import {
  setToolbarOptionsPanel,
  updateTool,
} from "../../../redux/actions/canvas_editor";

const Delete = ({
  canvas_editor: { activeObject, fabricCanvases },
  onSubmit,
  wizard_attach_task,
}) => {
  const handleDelete = () => {
    setToolbarOptionsPanel("");

    showAlertbox({
      color: "red",
      title: __("general.alert.are-you-sure"),
      description: __("plan_version_preview.alert.delete_confirmation"),
      buttons: [
        {
          color: "lightGray",
          text: __("general.alert.no-close"),
          onClick: "close",
        },
        {
          color: "gray",
          text: __("general.alert.yes-delete"),
          onClick: () => {
            Object.entries(fabricCanvases).forEach(([pageNumber, canvas]) => {
              const discardActiveObject = canvas.getActiveObject();

              if (!discardActiveObject) return;

              canvas.discardActiveObject();

              if (discardActiveObject.type === "activeSelection") {
                discardActiveObject.getObjects().forEach((obj) => {
                  canvas.remove(obj);
                });
              } else {
                canvas.remove(discardActiveObject);
              }

              canvas.requestRenderAll();

              updateTool({ tool: "hand" });

              canvas.fire("batch:removed");
            });

            hideAlertbox();
          },
        },
      ],
    });
  };

  const handleKeyDown = useCallback(
    (e) => {
      if (
        (e.key === "Delete" || e.key === "Backspace") &&
        !!activeObject &&
        !activeObject.isEditing
      ) {
        e.preventDefault();
        handleDelete();
      }
    },
    [activeObject],
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  if (!activeObject) return null;

  return (
    <Button
      id="delete"
      label={__("canvas.toolbar.delete")}
      icon={DeleteIcon}
      onClick={handleDelete}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
    wizard_attach_task: _.get(state.table, "all_tasks.attach_task_wizard"),
  };
};

export default connect(mapStateToProps, null)(Delete);
